import React from "react";
import HolidayRowNew from "./HolidayRowNew";
import moment from "moment";

// ----------------------------
// Hulp: groepeer vakanties per user
// ----------------------------
function groupByEmployee(raw) {
    const grouped = {};

    (raw || []).forEach(item => {
        if (!grouped[item.employeeEmail]) {
            grouped[item.employeeEmail] = {
                name: item.employeeName,
                email: item.employeeEmail,
                workSessions: []
            };
        }

        grouped[item.employeeEmail].workSessions.push({
            date: (item.date || "").substring(0, 10),
            numberOfHours: item.numberOfHours
        });
    });

    return Object.values(grouped);
}

// ----------------------------
// NIEUWE: simpele, eigen header voor grid-layout
// ----------------------------
const HolidayGridHeader = ({ days }) => {
    const workDays = days.slice(0, 5); // ma–vr

    return (
        <div className="holiday-grid-header-simple">
            <div></div> {/* lege kolom voor naam */}
            {workDays.map((day, i) => (
                <div key={i}>
                    {day.toLocaleDateString("nl-NL", { weekday: "short" })}
                    <br />
                    {day.toLocaleDateString("nl-NL", {
                        day: "numeric",
                        month: "short"
                    })}
                </div>
            ))}
        </div>
    );
};

// ----------------------------
// Hoofdcomponent
// ----------------------------
const HolidayList = ({ rawHolidays, days }) => {
    const employees = groupByEmployee(rawHolidays || []);
    const weeknummer = moment(days[0]).week();

    return (
        <div className="registration-table">

            {/* Titelblok */}
            <div className="customer-row open">
                <div className="customer-row-header indent-0">
                    VAKANTIES – Week {weeknummer}
                </div>

                <div className="category-block">

                    {/* ============================ */}
                    {/*   NIEUWE GRID HEADER         */}
                    {/* ============================ */}
                    <HolidayGridHeader days={days} />

                    {/* ============================ */}
                    {/*   GRID RIJEN VOOR PERSONEN   */}
                    {/* ============================ */}
                    {employees.map(emp => (
                        <HolidayRowNew
                            key={emp.email}
                            employee={emp}
                            days={days}
                            workSessions={emp.workSessions}
                        />
                    ))}

                </div>
            </div>
        </div>
    );
};

export default HolidayList;
